import { useTooltip } from './hooks'
import { TooltipContext } from './TooltipContext'
import type { TooltipOptionsType } from './types'

export const Tooltip = ({
  children,
  ...options
}: { children: React.ReactNode } & TooltipOptionsType) => {
  // This can accept any props as options, e.g. `placement`,
  // or other positioning options.
  const tooltip = useTooltip(options)
  return (
    <TooltipContext.Provider value={tooltip}>
      {children}
    </TooltipContext.Provider>
  )
}
